<template>
  <div>
    <div class="row">
      <h2>Lexicon builds list <b>({{this.desc}})</b></h2>
    </div>

    <div class="row">
      <span>
        Displays and manages builds list for transcribe lexicons. click "<u>View/Add Words</u>" to go to words list and submit builds for this list.
      </span>
    </div>

    <div class="row text-center">
      <div class="col-md-12"><br />
        <!-- <label class="btn btn-secondary" @click.stop="onManageSuggestions()">
          Manage suggestions
        </label>&nbsp; -->
        <label class="btn mx-1 mt-1 btn-primary btn-md" @click.stop="navigateToLexiconWordsList()">
          View/Add Words
        </label>
      </div>
    </div>
    <div class="row d-flex justify-content-center" v-if="this.requestCompleted && this.rows.length === 0">
      <div>
        <br /><br /><br /><br />
        Builds list is empty, click on "View/Add words" to add to the list.<br />
      </div>
    </div>

    <div v-if="this.requestCompleted && this.rows.length === 0" class="row d-flex justify-content-center">
      <img src="@/assets/no-data.png" />
    </div>

    <br v-if="this.displayFlash" />
    <div v-if="this.displayFlash" class="alert alert-success" role="alert" style="width: 30%;">
      ID was copied successfully to clipboard.
    </div>

    <div class="d-flex flex-row-reverse" v-if="this.actionsList.length > 0">
      <label class="btn btn-outline-danger" @click.stop="deleteLexiconBuilds()">
        Delete selected builds
      </label>&nbsp;
    </div>
    <div v-if="this.rows.length > 0">
      <div class="d-flex flex-row-reverse">
        <label class="btn mx-1 mt-1 btn-primary btn-md" @click.stop="reloadPage()">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"></path>
            <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"></path>
          </svg>
        </label>
      </div>
      <grid :styles="gridStyle" :cols="cols" :rows="rows" :sort="true" :pagination="pagination" :search="search"></grid>
    </div>

    <div v-if="this.displayLoading" class="d-flex justify-content-center">
      <div>
        <br /><br /><br />
        <br /><br /><br />
        <button class="btn btn-primary" type="button" disabled>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading data, please wait...
        </button>
      </div>
    </div>
    <vue-confirm-dialog></vue-confirm-dialog>
  </div>
</template>

<script>
import apiClient from '@/services/api_client_saas.js'
import Grid from 'gridjs-vue'
import router from '../router'

export default {
  props: {
  },
  components: {
    Grid
  },
  data () {
    return {
      desc: {},
      rows: [],
      displayLoading: true,
      actionsList: [],
      requestCompleted: false,
      uploadURL: '',
      groupId: 0,
      displayFlash: false,
      pagination: true,
      search: true,
      gridStyle: {
        table: {
          border: '3px solid #ccc'
        },
        th: {
          'background-color': 'rgba(0, 0, 0, 0.1)',
          color: '#000',
          'border-bottom': '3px solid #ccc',
          'text-align': 'center'
        },
        td: {
          'text-align': 'center'
        }
      },
      cols: [
        {
          name: 'Build Description',
          formatter: (cell, row) => {
            return this.$gridjs.html(cell)
          }
        },
        {
          name: 'ID',
          width: '15%',
          formatter: (cell, row) => {
            const currentTime = new Date().getTime()
            const buildTime = Date.parse(row.cells[1].data)
            const difference = Math.abs(currentTime - buildTime)
            const duration = difference / (1000 * 3600)

            let displayHtml = ''
            if (!cell) {
              if (duration >= 24) {
                displayHtml = '<span style="color: red"><u>Build seems to be corrupted.</u></span>'
              } else {
                displayHtml = '<span style="color: orange"><u>Build is in progress, No build ID available.</u></span>'
              }
            } else {
              displayHtml = '<span style="color: green"><u>' + cell + '</u></span>'
              displayHtml += '<span data-v-6a256646="" title="Copy" class="clickable ml-2"><svg data-v-6a256646="" viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" alt="icon" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-subtract b-icon bi" data-clipboard-click-handler="$1"><g data-v-6a256646=""><path d="M4 12v2.5A1.5 1.5 0 0 0 5.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 4H12v6.5a1.5 1.5 0 0 1-1.5 1.5H4z"></path><path fill-rule="evenodd" d="M10.5 1h-9a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zm-9-1A1.5 1.5 0 0 0 0 1.5v9A1.5 1.5 0 0 0 1.5 12h9a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 10.5 0h-9z"></path></g></svg></span>'
            }

            const linkAction = this.$gridjs.h(
              'span',
              { onClick: () => this.copyToClp(cell) },
              this.$gridjs.html(displayHtml)
            )

            return [linkAction]
          }
        },
        {
          name: 'Build Date',
          formatter: (cell) => this.$gridjs.html('<span><u>' + cell + '</u></span>')
        },
        {
          name: 'Build Status',
          formatter: (cell, row) => {
            let statusHtml = '<span><u style="color:orange;">In progress...</u></span>'
            if (row.cells[1].data) {
              statusHtml = '<span style="color: green;"><b>Build Completed</b></span>'
            }

            return this.$gridjs.html(statusHtml)
          }
        },
        {
          name: 'Bulk Actions',
          sort: false,
          width: '4%',
          formatter: (cell, row) => {
            let checkbox = '<input id="check-' + row.cells[4].data + '" class="align-center justify-center" type="checkbox" value="" id="flexCheckDefault">'
            for (const i in this.actionsList) {
              if (this.actionsList[i] === row.cells[4].data) {
                checkbox = '<input id="check-' + row.cells[4].data + '" checked=checked class="align-center justify-center" type="checkbox" value="" id="flexCheckDefault">'
              }
            }

            const actionList = this.$gridjs.h(
              'span',
              { onClick: () => this.addToActionList(row.cells[4].data) },
              this.$gridjs.html(checkbox)
            )
            return [actionList]
          }
        }
      ]
    }
  },
  mounted: function () {
    this.groupId = this.$route.params.id

    apiClient.get('/api/lexicons/item/' + this.groupId).then((response) => {
      this.desc = response.data.group[0].lexicon_description
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })

    apiClient.get('/api/lexicon/builds/list/' + this.groupId).then((response) => {
      response.data.forEach((item, key) => {
        this.rows.push([
          item.build_desc,
          item.lexicon_id,
          item.request_date,
          item.status,
          item.id
        ])
      })
      this.requestCompleted = true
      this.displayLoading = false
      console.log(this.rows)
    }).catch((error) => {
      if (error.response) {
        console.log(error.response.data)
      }
    })

    setInterval(() => {
      this.reloadPage(1)
    }, 60000)
  },
  methods: {
    deleteLexiconBuilds: function (id) {
      this.$confirm({
        message: 'You are about to delete the selected builds, Are you sure?',
        button: {
          no: 'No',
          yes: 'Yes, Delete.'
        },
        callback: (confirm) => {
          if (confirm) {
            apiClient.put('/api/lexicon/builds/delete', {
              id: this.actionsList.join(',')
            }).then((response) => {
              if (response.status === 204) {
                this.actionsList = []

                apiClient.get('/api/lexicon/builds/list/' + this.groupId).then((response) => {
                  this.rows = []
                  response.data.forEach((item, key) => {
                    this.rows.push([
                      item.build_desc,
                      item.lexicon_id,
                      item.request_date,
                      item.status,
                      item.id
                    ])
                  })
                  this.requestCompleted = true
                }).catch((error) => {
                  if (error.response) {
                    console.log(error.response.data)
                  }
                })
              }
            }).catch((error) => {
              if (error.response) {
                console.log(error.response.data)
              }
            })
          }
        }
      })
    },
    reloadPage: function () {
      apiClient.get('/api/lexicon/builds/list/' + this.groupId).then((response) => {
        this.rows = []
        response.data.forEach((item, key) => {
          this.rows.push([
            item.build_desc,
            item.lexicon_id,
            item.request_date,
            item.status,
            item.id
          ])
        })
        this.requestCompleted = true
      }).catch((error) => {
        if (error.response) {
          console.log(error.response.data)
        }
      })
    },
    navigateToLexiconWordsList: function () {
      router.push({ name: 'LexiconWords', params: { id: this.groupId } })
    },
    onManageSuggestions: function (event) {
      router.push({ name: 'LexiconSuggestionsManagement', params: { id: this.groupId } })
    },
    addToActionList: function (id) {
      if (document.getElementById('check-' + id).checked && !this.actionsList.includes(id)) {
        this.actionsList.push(id)
      } else if (!document.getElementById('check-' + id).checked) {
        const index = this.actionsList.indexOf(id)
        if (index !== -1) {
          this.actionsList.splice(index, 1)
        }
      }
    },
    copyToClp: function (text) {
      if (window.clipboardData && window.clipboardData.setData) {
        return window.clipboardData.setData('Text', text)
      } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
        var textarea = document.createElement('textarea')
        textarea.textContent = text
        textarea.style.position = 'fixed'
        document.body.appendChild(textarea)
        textarea.select()
        try {
          return document.execCommand('copy')
        } catch (ex) {
          console.warn('Copy to clipboard failed.', ex)
          return false
        } finally {
          document.body.removeChild(textarea)
          this.displayFlash = true
          setTimeout(() => {
            this.displayFlash = false
          }, 2000)
        }
      }
    }
  }
}
</script>
